import React from 'react';
import Slider from 'react-slick';
import { Icon } from '@iconify/react';
import Brand from '../Brand/Brand';
import SectionHeading from "../SectionHeading/SectionHeading";


const BrandSlider = ({ data }) => {
  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <div {...props} className={'slick-arrow-left slick-arrow' + (currentSlide === 0 ? ' slick-disabled' : '')} aria-hidden="true" aria-disabled={currentSlide === 0 ? true : false} >
      <Icon icon="fa-solid:angle-left" />
    </div>
  );

  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <div {...props} className={'slick-arrow-right slick-arrow' + (currentSlide === slideCount - 1 ? ' slick-disabled' : '')} aria-hidden="true" aria-disabled={currentSlide === slideCount - 1 ? true : false} >
      <Icon icon="fa-solid:angle-right" />
    </div>
  );


  const settings = {
    dots: false,
    infinite: true,
    loop: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    responsive: [
      {
        breakpoint: 1599,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          dots: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          dots: true
        }
      }
    ]
  }
  return (
    <div className="st-gray-bg">
      <div className="st-height-b120 st-height-lg-b80" />
      <div className="container">
      <SectionHeading title="We Accept All Insurance Providers" />
      <div className="st-height-b40 st-height-lg-b40" />


        <Slider {...settings} className='st-slider-style2'>
          {
            data.map((elements, index) => (
              <Brand {...elements} key={index} />
            ))
          }
        </Slider>
      </div>
      
    </div>
  )
}

export default BrandSlider;
